//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./meeting_stage.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// enum MeetingStage.Stage
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias MeetingStage.Stage
 */
class MeetingStage_Stage extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct MeetingStage
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingStage.Mutable`. */
export class MeetingStage extends $._FrozenBase {}

function initMeetingStage(target, initializer) {
  target.stage = MeetingStage_Stage.create(initializer.stage ?? MeetingStage_Stage.UNKNOWN);
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "meeting_stage.skir",
  [
    {
      kind: "enum",
      ctor: MeetingStage_Stage,
      name: "Stage",
      parentCtor: MeetingStage,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "BOT_CREATED",
          number: 1,
        },
        {
          name: "BOT_IN_WAITING_ROOM",
          number: 2,
        },
        {
          name: "BOT_IN_CALL_NOT_RECORDING",
          number: 3,
        },
        {
          name: "BOT_IN_CALL_RECORDING",
          number: 4,
        },
        {
          name: "BOT_IN_CALL_RECORDING_PAUSED",
          number: 5,
        },
        {
          name: "FINISHED",
          number: 6,
        },
        {
          name: "POST_PROCESSING_DONE",
          number: 7,
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingStage,
      initFn: initMeetingStage,
      name: "MeetingStage",
      fields: [
        {
          name: "stage",
          property: "stage",
          number: 0,
          type: {
            kind: "record",
            ctor: MeetingStage_Stage,
          },
        },
      ],
    },
  ]
);
